// If using ES modules or Webpack with ES module syntax
export default (function (root, factory) {
    if ( typeof define === 'function' && define.amd ) {
        define([], factory(root));
    } else if ( typeof exports === 'object' ) {
        module.exports = factory(require());
    } else {
        root.stickMe = factory(root);
    }
})(typeof global !== "undefined" ? global : this.window || this.global, function (root) {
  /**
   * Variables
   */

  var stickMe = {};
  var supports = !!document.querySelector && !!root.addEventListener;
  var settings = {}; // Modified: Settings are now managed per instance

  // Default settings
  var defaults = {
    element              : "js-sticky",
    wrapper              : "js-stickyWrapper",
    classNameSticky      : "is-sticky",
    classNameSunk        : "is-sunk",
    classNameSunkWrapper : "is-sunk-wrapper",
    offset               : 48
  };


  //
  // Methods
  //

  /**
   * Handle events
   * @private
   * @param {event} Event
   */
  var eventHandler = function ( element, instanceSettings, event ) { // Modified: Pass element and settings
    // On scroll
    if ( event.type === "scroll" ) {
      // Debounce scroll and trigger stickyness
      handleScrollEvents( element, instanceSettings ); // Modified: Pass element and settings
    }
  };

  /**
   * Handle scroll events efficiently
   * @private
   */
  var handleScrollEvents = function ( element, instanceSettings ) { // Modified: Pass element and settings
    var latestKnownScrollY = 0,
        ticking = false;

    function onScroll() {
      latestKnownScrollY = window.scrollY;
      requestTick();
    }

    function requestTick() {
      if ( !ticking ) {
        requestAnimationFrame( update );
      }
      ticking = true;
    }

    function update() {
      // reset the tick so we can
      // capture the next onScroll
      ticking = false;

      var currentScrollY = latestKnownScrollY;

      // Activate the stickyness
      activate( element, instanceSettings, currentScrollY ); // Modified: Pass element and settings
    }

    onScroll();

  };

  /**
   * Extend defaults with user options
   * @private
   * @param {object} source
   * @param {object} properties
   */
  var extendDefaults = function ( source, properties ) {
    var property;

    for ( property in properties ) {
      if ( properties.hasOwnProperty( property ) ) {
        source[property] = properties[property];
      }
    }

    return source;
  };

  /**
   * Get top and left position of element
   * @private
   * @param {node} element
   */
  var getOffset = function ( element ) {
    element = element.getBoundingClientRect();

    return {
      left: element.left + window.scrollX,
      top: element.top + window.scrollY
    }
  }

  /**
   * Stick element in place
   * @private
   * @param {node} element
   */
  var stick = function ( element, instanceSettings ) { // Modified: Pass settings
    var width = element.offsetWidth;
    //var width = getRectangle( element ).width;

    element.classList.add( instanceSettings.classNameSticky ); // Modified: Use instance settings

    css( element, {
      top: instanceSettings.offset + "px", // Modified: Use instance settings
      width: width + "px"
    });
  }

  /**
   * Unstick our stuck element
   * @private
   * @param {node} element
   */
  var unStick = function ( element, instanceSettings ) { // Modified: Pass settings
    element.classList.remove( instanceSettings.classNameSticky ); // Modified: Use instance settings
    element.style.top = "";
    element.style.width = "";
  }

  /**
   * Sink element to bottom of wrapper
   * @private
   * @param {node} element
   * @param {node} wrapper
   */
  var sink = function ( element, wrapper, instanceSettings ) { // Modified: Pass settings
    element.classList.add( instanceSettings.classNameSunk ); // Modified: Use instance settings
    wrapper.classList.add( instanceSettings.classNameSunkWrapper ); // Modified: Use instance settings
  }

  /**
   * Unsink our sunk element
   * @private
   * @param {node} element
   * @param {node} wrapper
   */
  var unSink = function ( element, wrapper, instanceSettings ) { // Modified: Pass settings
    element.classList.remove( instanceSettings.classNameSunk ); // Modified: Use instance settings
    wrapper.classList.remove( instanceSettings.classNameSunkWrapper ); // Modified: Use instance settings
  }

/**
 * Activate stickyness
 * @private
 * @param {node} element
 * @param {object} instanceSettings Settings specific to this instance
 * @param {string} position Scroll position
 */
var activate = function ( element, instanceSettings, position ) { // Modified: Accept element and settings

    var wrapper = element.closest('.' + instanceSettings.wrapper); // Modified: Find wrapper relative to element

    // Sprawdzamy, czy elementy istnieją
    if (!element || !wrapper) {
        return; // Jeśli nie, przerywamy funkcję
    }

    var height  = wrapper.offsetHeight - element.offsetHeight,
        top     = getOffset( wrapper ).top,
        bottom  = ( top + height ) - instanceSettings.offset, // Modified: Use instance settings
        start   = top - instanceSettings.offset; // Modified: Use instance settings

    if ( position >= start ) {

        if ( position >= bottom ) {

            unStick( element, instanceSettings ); // Modified: Pass settings
            sink( element, wrapper, instanceSettings ); // Modified: Pass settings

        } else {

            stick( element, instanceSettings ); // Modified: Pass settings
            unSink( element, wrapper, instanceSettings ); // Modified: Pass settings

        }

    } else {

        unStick( element, instanceSettings ); // Modified: Pass settings

    }

}

  /**
   * A helper function for adding/remove CSS properties
   * @private
   * @param {node} element
   * @param {object} properties
   */
  var css = function ( element, properties ) {

    for ( var property in properties ) {

      if ( properties.hasOwnProperty( property ) ) {

        element.style[ property ] = properties[ property ];

      }

    }

  };

  /**
   * A function that returns element width, height, top, and left
   * @private
   * @param {node} element
   * @return {object}
   */
  var getRectangle = function ( element ) {

    css( element, { position: '', width: '', top: '', left: '' } );

    var width = Math.max( element.offsetWidth, element.clientWidth, element.scrollWidth );
    var height = Math.max( element.offsetHeight, element.clientHeight, element.scrollHeight );

    var top = 0;
    var left = 0;

    do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while ( element );

    return { top: top, left: left, width: width, height: height };
  };

  /**
   * Destroy current initialisation
   * @public
   */
  stickMe.destroy = function (element) {
        if (!element._stickyData) return;

        window.removeEventListener("scroll", element._stickyData.scrollHandler);

        // Reset styles and classes
        element.classList.remove(element._stickyData.settings.classNameSticky, element._stickyData.settings.classNameSunk);
        element.style.top = "";
        element.style.width = "";

        var wrapper = element._stickyData.wrapper;
        wrapper.classList.remove(element._stickyData.settings.classNameSunkWrapper);

        // Clean up data
        delete element._stickyData;
  };

/**
 * Initialise plugin
 * @public
 * @param {Object} options User settings
 */
stickMe.init = function ( options ) {
  if ( !supports ) return;

  var allSettings = extendDefaults(defaults, options || {});

  // Szukamy wszystkich elementów
  var elements = document.querySelectorAll('.' + allSettings.element);



  // Dla każdego elementu - inicjujemy obsługę
  elements.forEach(function( element ) {
    // Destroy existing initialization if it exists
    if (element._stickyData) {
      stickMe.destroy(element);
    }

    // Find the wrapper for the current element (must be a parent)
    var wrapper = element.closest('.' + allSettings.wrapper);

    if (!wrapper) {
      console.warn('stickMe: Wrapper element not found for element. Skipping.');
      return;
    }

    // Extend defaults for *this* instance
    var instanceSettings = extendDefaults({}, allSettings);

    // Przypisujemy dane do elementu
    element._stickyData = {
      wrapper: wrapper,
      isSticky: false,
      isSunk: false,
      settings: instanceSettings // Store the settings for this instance
    };

    // Create scroll handler (with bound 'this' and settings)
    var scrollHandler = function(event) {
      eventHandler(element, instanceSettings, event); // Pass element and settings
    };

    // Attach the scroll handler to the window
    window.addEventListener("scroll", scrollHandler);

    // Store the scroll handler for later removal in the destroy method
    element._stickyData.scrollHandler = scrollHandler;

    // Initial call to set initial state
    handleScrollEvents(element, instanceSettings); // Pass element and settings
  });
}
  return stickMe;
});
